/**
 * Web Vitals — initialize once at app startup.
 *
 * Sends each metric to:
 * 1. Umami (via trackEvent) — available in the analytics dashboard
 * 2. Backend POST /api/vitals — for structured log aggregation
 */
import { onLCP, onFID, onCLS, onINP, onTTFB, onFCP } from 'web-vitals';
import { trackEvent } from './analytics';
import { config } from '../config';

interface Metric {
  name: string;
  value: number;
  rating: string;
}

function sendVital(metric: Metric): void {
  // Send to Umami
  trackEvent('web_vital', {
    metric: metric.name,
    value: Math.round(metric.value),
    rating: metric.rating,
  });

  // Send to backend via sendBeacon (non-blocking, survives page unload)
  if (!config.apiUrl) return;
  try {
    const payload = JSON.stringify({
      name: metric.name,
      value: metric.value,
      rating: metric.rating,
      url: window.location.pathname,
      timestamp: Date.now(),
    });
    navigator.sendBeacon(`${config.apiUrl}/api/vitals`, new Blob([payload], { type: 'application/json' }));
  } catch {
    // analytics must never break the app
  }
}

export function initVitals(): void {
  onLCP(sendVital);
  onFID(sendVital);
  onCLS(sendVital);
  onINP(sendVital);
  onTTFB(sendVital);
  onFCP(sendVital);
}
